


























































































import { Component, Vue, Watch } from "vue-property-decorator";
import { bus } from "@/bus";
// components
import vSelect from "vue-select";
import FolderTree from "@/components/common/folders/FolderTree.vue";
// service methods
import { getFilteredChannelGroups } from "@/services/channels/channelGroupService";
import { getAllTemplates } from "@/services/templates/templateService";
import { getSolutions } from "@/services/solutions/solutionService";
// types
import { ChannelGroup, ChannelGroupsFilterDtoIn } from "@/services/channels/types";
import { Folder, FolderEntites } from "@/services/folders/types";
import { Option } from "@/services/common/types";
import { channelGroupsModalFields } from "@/components/channels/fields/channelGroupsModalFields";

@Component({
    components: {
        vSelect,
        "folder-tree": FolderTree
    }
})
export default class SelectChannelGroupModal extends Vue {
    // local state
    channelGroups = [] as Array<ChannelGroup>;
    selectedChannelGroups = [] as Array<ChannelGroup>;
    fields = channelGroupsModalFields;
    isBusy = false;

    // folders
    folderEntity = FolderEntites.ChannelGroups;
    selectedFolderNode = {} as Folder;
    showFolderTree = true;

    // filter
    selectedTemplate = null as Option | any;
    selectedSolution = null as Option | any;
    filterWidth = "" as string;
    filterHeight = "" as string;

    // filter options
    templates = [] as Array<Option>;
    solutions = [] as Array<Option>;
    searchText = "" as string;

    multiPicker = false;

    open(multiPicker = false) {
        this.multiPicker = multiPicker;
        this.fetchData();
        this.$bvModal.show("modal-channelGroups");
    }

    select(items: ChannelGroup[]) {
        this.selectedChannelGroups = items;
    }

    save() {
        this.$emit("select", this.selectedChannelGroups.map(x => {
            return {
                id: x.id,
                name: x.name
            };
        }));
        this.$bvModal.hide("modal-channelGroups");
    }

    // methods & actions
    setSelectedFolder(folder: Folder) {
        this.selectedFolderNode = folder;
    }

    toggleFolderTree() {
        if (!this.filterActive) {
            this.showFolderTree = !this.showFolderTree;
        }
    }

    fetchData() {
        this.loadChannelGroups();
        getAllTemplates().then(response => {
            this.templates = response.map(x => ({
                id: x.id,
                text: x.name
            }));
        });
        getSolutions().then(response => {
            this.solutions = response.map(x => ({
                id: x.id,
                text: x.name
            }));
        });
    }

    loadChannelGroups() {
        this.isBusy = true;
        this.channelGroups = [] as Array<ChannelGroup>;
        getFilteredChannelGroups({
            templateId: this.selectedTemplate ? this.selectedTemplate.id : "",
            solutionsId: this.selectedSolution ? this.selectedSolution.id : ""
        } as ChannelGroupsFilterDtoIn).then(response => {
            this.channelGroups = response;
            this.isBusy = false;
        });
    }

    clearFilter() {
        this.selectedTemplate = null;
        this.selectedSolution = null;
        this.filterWidth = "";
        this.filterHeight = "";
        this.loadChannelGroups();
    }

    resetState() {
        this.selectedTemplate = null;
        this.selectedSolution = null;
        this.searchText = "";
        this.filterWidth = "";
        this.filterHeight = "";
    }

    // computed and watchers
    get model(): Array<ChannelGroup> {
        if (this.filterActive) {
            return this.channelGroups.filter(
                x => (this.searchText === "" ? true : x.name.toLowerCase().includes(this.searchText.toLowerCase())) &&
                    (this.filterWidth === "" ? true : x.width === +this.filterWidth) &&
                    (this.filterHeight === "" ? true : x.height === +this.filterHeight)
            );
        } else {
            return this.channelGroups.filter(
                x => this.selectedFolderNode.id ? x.folderId === this.selectedFolderNode.id : true
            );
        }
    }

    get filterActive(): boolean {
        return (
            (this.selectedTemplate && Object.keys(this.selectedTemplate.id).length > 0) ||
            (this.selectedSolution && Object.keys(this.selectedSolution.id).length > 0) ||
            this.searchText !== "" ||
            this.filterWidth !== "" ||
            this.filterHeight !== "");
    }

    @Watch("filterActive")
    onFilterChanged(value: any, oldValue: any) {
        this.showFolderTree = !value;
    }
}
